import React, { Component } from 'react';
import { observer } from 'mobx-react';
import DeliveryListTable from './DeliveryListTable';
import { Global } from '../../../../GlobalClass';
import { ROUTER } from '../../../../common/route';
// import { reviewProductStores } from '../../stores/ReviewProductStores';
// import ProductReviewModal from '../ReviewProduct/ProductReviewModal';
import { getParamURL } from '../../../../helpers/CF';
import { history } from '../../../../history';
import { userDetailStores } from 'src/pages/UserManagement/stores/UserDetailStores';
import UserDetailModal from 'src/pages/UserManagement/components/UserDetail/UserDetailModal';
import RadioGroup from 'src/pages/components/RadioGroup/RadioGroup';
import { deliveryListStores } from '../../stores/DeliveryListStores';
// import ConvertToBiddingModal from '../ConvertToBiddingModal/ConvertToBiddingModal';

class DeliveryList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productDetailModal: false,
            productId: null,
        }
    }

    onHideProductModal = () => {
        this.setState({ productDetailModal: false, productId: null });
        Global.push(ROUTER.PRODUCT.INDEX);
    }

    onPickupProduct = async (item) => {
        const { confirmPickUpProduct } = deliveryListStores;
        await confirmPickUpProduct(item.id);
        console.log(`pickup product ${item.id}`)
    }

    onDeliverProduct = async (item) => {
        const { confirmDeliverProduct } = deliveryListStores;
        await confirmDeliverProduct(item.id)
        console.log(`deliver product ${item.id}`)
    }

    onCancelOrder = async (item, note) => {
        
        const { confirmCancelOrder } = deliveryListStores;
        await confirmCancelOrder(item.id, note);
        console.log(`cancel order ${item.id}`)
    }

    onShowUserInfo = (userId) => {
        if (!userId) return;
        userDetailStores.setUserIdForLoadDetail(userId);
        userDetailStores.onChangeUserDetailModal(true);
    }

    onSelectedFilter = async ({ item }) => {
        const filter = item.id;
        const { setProductTablePage, setProductFilterSelected, getTotalProductCount, getProductListStore } = deliveryListStores;
        setProductFilterSelected(filter);
        setProductTablePage(1);
        await getTotalProductCount(deliveryListStores.productFilterSelected); // không khai báo trước productFilterSelected ở trên nếu k sẽ lấy giá trị cũ (giá trị lúc khai báo)
        getProductListStore();
    }

    render() {
        const { productDetailModal } = this.state;
        const { productFilterSelected } = deliveryListStores;
        return (
            <div className="card">
                <div id='product-list' className='v-radio'>
                    <RadioGroup
                        inputKey='product-list'
                        containerStyle={{ marginRight: 32 }}
                        checkedId={productFilterSelected}
                        onItemClicked={this.onSelectedFilter}
                        // datas={radioFilterProductListData}
                    />
                </div>
                <div className="card-body">
                    <DeliveryListTable
                        onShowUserInfo={this.onShowUserInfo}
                        onPickupProduct={this.onPickupProduct}
                        onDeliverProduct={this.onDeliverProduct}
                        onCancelOrder={this.onCancelOrder}
                    />
                </div>

                {/* <ProductReviewModal isShow={productDetailModal} onHide={this.onHideProductModal} /> */}

                <UserDetailModal />
            </div>
        );
    }

    componentDidMount = async () => {
        // const { getRejectTypeListAction, productRejectTypeList } = reviewProductStores;
        // if (!productRejectTypeList.length) await getRejectTypeListAction();
        if (history.location.pathname == ROUTER.PRODUCT.INDEX) {
            const productId = getParamURL(this.props, 'pId');
            if (!!productId)
                this.setState({ productId, productDetailModal: true });
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        // const { productDetailModal } = this.state;
                // if (prevState.productDetailModal !== productDetailModal) {
                //     const {
                //         getReviewProductDetailAction,
                //         getProductHistoryInReviewProductAction,
                //         setSupportConversationsPage,
                //         setSupportConversationList
                //     } = reviewProductStores;
                //     if (productDetailModal) {
                //         getReviewProductDetailAction(this.state.productId);
                //         getProductHistoryInReviewProductAction(this.state.productId);
                //     } else {
                //         setSupportConversationsPage(1);
                //         setSupportConversationList([]);
                //     }
                // }
    };
}

export default observer(DeliveryList);